import { Pipe, PipeTransform } from '@angular/core';

import { type DateFormatStyle, formatDate } from '../utils/locale-format.util';

/**
 * Formats a date in the active language. The locale is an explicit argument so a language switch
 * re-renders every timestamp: `{{ value | nfDate: dateLocale() : 'short' }}`.
 */
@Pipe({ name: 'nfDate' })
export class NfDatePipe implements PipeTransform {
  transform(
    value: Date | string | number | null | undefined,
    locale: string,
    style: DateFormatStyle = 'medium',
  ): string {
    return formatDate(value, locale, style);
  }
}
